<template>
  <div>
    <div v-if="loadingItemWarehouses" class="mb-5 pb-5">
      <loading-animation />
    </div>

    <b-card-body>
      <div class="row mx-md-n3 mx-1 mb-2 align-items-end">
        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-8 mb-xl-0 mb-3">
          <b-form-group
            label="Nome"
            label-for="warehousesSearchText"
            class="mb-0"
          >
            <b-form-input
              id="warehousesSearchText"
              v-model="warehousesSearchText"
              @keyup.enter="searchItemWarehouses"
              placeholder="Procurar por..."
            />
          </b-form-group>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-4">
          <button @click="searchItemWarehouses" type="button" class="btn btn-primary">Buscar</button>
        </div>
      </div>

      <div v-if="warehouseAppliedFilters.length" class="row mb-2 mx-0">
        <div v-for="(filter, index) in warehouseAppliedFilters" class="col-auto px-1" :key="index">
          <h5>
            <span class="badge badge-warning">{{filter.label}} = {{filter.value}}</span>
          </h5>
        </div>
      </div>

      <div class="row mx-md-n3 mx-1" v-if="hasWarehouses">
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12" v-for="(warehouse, index) in item.warehouses" :key="index">
          <div class="card">
            <div class="card-body mx-md-0 mx-3">
              <div class="h4 mb-0 cursor-pointer"  :id="warehouse.id">
                {{ warehouse.quantity }}
              </div>

              <small class="text-muted font-weight-bold">{{ warehouse.name }}</small>
            </div>
          </div>
        </div>
      </div>

      <b-row v-else class="justify-content-center pt-3">
        <h6 class="col-auto">Nenhum armazém encontrado para a pesquisa</h6>
      </b-row>
    </b-card-body>
  </div>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders'
  import { httpClient } from '@/service';
  import shared from '@/shared/shared'

  export default {
    name: 'item-warehouses',
    components: {
      LoadingAnimation
    },

    props: {
      item: {
        type: Object,
        required: true
      },
      updateItem: {
        type: Function,
        required: true
      }
    },

    data () {
      return {
        loadingItemWarehouses: false,
        itemWarehousesSearched: false,
        warehousesSearchText: null,
      }
    },

    beforeMount: function () {
      this.warehousesSearchText = shared.getLocalStorageString('items/show/warehouses/warehousesSearchText', this.warehousesSearchText);
    },

    computed: {
      hasWarehouses() {
        return !this.loadingItemWarehouses && this.item && this.item.warehouses && this.item.warehouses.length;
      },

      warehouseAppliedFilters() {
        let appliedFilters = [];

        if (this.warehousesSearchText && this.warehousesSearchText.length) {
          appliedFilters.push({ label: 'Nome', value: this.warehousesSearchText });
        }

        return appliedFilters;
      },
    },

    methods: {
      tabChanged() {
        if (!this.itemWarehousesSearched) {
          this.searchItemWarehouses();
          this.itemWarehousesSearched = true;
        }
      },

      searchItemWarehouses() {
        if (this.loadingItemWarehouses) {
          return;
        }

        this.loadingItemWarehouses = true;
        let conditions = [
          {
            logicalOperator: 'OR',
            conditions: [
              {
                joinType: 'LEFT',
                field: 'locations.item.id',
                value: this.item.id
              },
              {
                joinType: 'LEFT',
                field: 'locations.balances.itemLot.item.id',
                value: this.item.id
              }
            ]
          },
          {
            field: 'active',
            value: true
          }
        ];

        if (this.warehousesSearchText && this.warehousesSearchText.length) {
          conditions.push({
            field: 'name',
            conditionalOperator: 'LIKE_START',
            value: this.warehousesSearchText
          });
        }
        shared.setLocalStorageString('items/show/warehouses/warehousesSearchText', this.warehousesSearchText);

        httpClient
        .post(`${process.env.VUE_APP_API_URL}stock-locales/condition/item/${this.item.id}/with-quantity?page=${0}&size=${1000}`, {
          conditions: conditions,
          distinct: true
        })
        .then(({ data }) => {
          this.loadingItemWarehouses = false;
          this.item.warehouses = data.data.content;

          if (!this.warehouses || !this.warehouses.length) {
            this.warehouses = JSON.parse(JSON.stringify(data.data.content));

            if (this.warehouses) {
              this.warehouses.unshift({id: null, name: 'Todos'});
            }
          }

          this.updateItem(this.item);
        })
        .catch((error) => {
          this.loadingItemWarehouses = false;
          if (error.message) {
            this.$notify.error(error)
          }

          this.item.warehouses = []
        });
      },
    }
  }
</script>

<style scoped>
</style>
